export default "__VITE_PUBLIC_ASSET__82a754e4__"